import { StockTransactionTabType } from './StockTransactionTabType';
import * as routes from '../routes';

export const StockTransactionsRouteRecord: Record<StockTransactionTabType, string> = {
	deliveries: routes.DeliveriesRoute,
	returns: routes.ReturnsRoute,
	'stock-movements': routes.StockMovementsRoute,
};
